// -----------------------------------------------------------------------------
// <copyright file="pendo.service.ts" company="ecoInsight, Inc.">
// Copyright © ecoInsight, Inc. All rights reserved.
// </copyright>
// ------------------------------------------------------------------------------

import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { APP_NAME, PENDO_DEFAULT_ACCOUNT_ID } from '../constants/global';
import { HttpHelperService } from './http.service';

declare let pendo: any;
declare let zE: any;

@Injectable({ providedIn: 'root' })
export class PendoService {
  constructor(private http: HttpHelperService) {}
  public helpUrl = 'https://ecoinsightcoe.zendesk.com/access/jwt?jwt=';
  private isPendoAvailable(): boolean {
    return typeof pendo !== 'undefined';
  }

  public initializePendo(
    visitorId: string,
    userDetails: any,
    accountId = PENDO_DEFAULT_ACCOUNT_ID,
  ) {
    pendo.initialize({
      visitor: {
        id: visitorId,
        full_name: userDetails.name,
        // full_name: `${userDetails.fname} ${userDetails.lname}`,
      },
      account: {
        id: accountId,
      },
    });
  }

  public reInitializePendo(
    visitorId: string,
    userDetails: any,
    accountId = PENDO_DEFAULT_ACCOUNT_ID,
  ) {
    if (this.isPendoAvailable()) {
      pendo.identify({
        visitor: {
          id: visitorId,
          full_name: userDetails.name,
        },
        account: {
          id: accountId,
        },
      });
    } else {
      pendo.initialize({
        visitor: {
          id: visitorId,
          full_name: userDetails.name,
        },
        account: {
          id: accountId,
        },
      });
    }
  }

  showLiveChat(name: string, email: string) {
    try {
      pendo.showGuideById('eQ-jFE-OTEFwCzWmilJKAKvL6S4@EW4Eq9RPGQ8xHBr-enT0PaY4LVs');
    } catch {
      // Pendo guide data not ready on first load; Zendesk chat still opens normally
    }
    zE('webWidget', 'identify', { name: `${name} [${APP_NAME}]`, email });
    zE('webWidget', 'prefill', {
      name: { value: `${name} [${APP_NAME}]`, readOnly: true },
      email: { value: email, readOnly: true },
    });
    (window as any)._vasLiveChatReady = true;
    zE('webWidget', 'show');
    zE('webWidget', 'open');
  }

  // updateTeamMetaData(team) {
  //     const payload = [{
  //       "visitorId": this.globalService.getDataFromStorage('vendor'),
  //       "values": {
  //         "team": team,
  //       }
  //     }];
  //     this.updateMetaData(payload).subscribe();
  // }

  public updateMetaData(pl: any) {
    return this.http.postPendo(`api/v1/metadata/visitor/custom/value`, pl).pipe(map((res) => res));
  }

  public getPendoReport() {
    const reportId = 'FK3alQUPGPvMEHu01iFeeZavXMw';
    return this.http.getPendo(`api/v1/report/${reportId}/results.csv`).pipe(map((res) => res));
  }

  public getZendeskToken() {
    return this.http.get(`api/GetZenDeskAuthToken`);
  }
}
